import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { ProductionEntityList } from '@data/keyIssues/key-issues';
import { initializeRequiredData } from '@data/pickList/pick-list';
import { accountMasterList } from '@data/weeklyVariance/weekly-variance';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface PdfPayload{
  payload:any;
  url:string;
  fileName:string;
  checkResponseForFileName?:boolean
}

@Injectable({
  providedIn: 'root'
})
export class PreviewPdfService {

  payloadList:PdfPayload[]=[];
  
  constructor(private http: HttpClient){}

  getPdf(payload:PdfPayload): Observable<any> {
      return this.http.post(payload.url, payload.payload ,{observe:'response',responseType:'blob'});   
  }


}
